"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioGroup = void 0;
var _react = _interopRequireWildcard(require("react"));
var _layout = require("../layout");
var _Radio = require("./Radio");
/** Object with Radio component props that can be given overrides */

const RadioGroup = _ref => {
  let {
    className,
    clientId,
    disabledOptions,
    getClientId,
    getOptionProps,
    isDisabled,
    isInvalid,
    isRequired = false,
    name,
    onChange,
    onInvalid = () => undefined,
    options,
    orientation = "vertical",
    selected,
    size = "large",
    spacing
  } = _ref;
  const disabledOptionLookup = (0, _react.useMemo)(() => {
    const lookup = {};
    (disabledOptions || []).forEach(opt => {
      lookup[opt.value] = opt;
    });
    return lookup;
  }, [disabledOptions]);
  const changeHandler = (option, e) => {
    if (e.target.ariaDisabled === "true") {
      e.preventDefault();
    } else {
      onChange(option, e);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_layout.Spacer, {
    space: spacing || getDefaultSpacing(orientation),
    orientation: orientation === "vertical" ? "column" : "row",
    className: className,
    clientId: clientId
  }, options.map(option => {
    const optionProps = getOptionProps ? getOptionProps(option) : {};
    return /*#__PURE__*/_react.default.createElement(_Radio.Radio, {
      name: name,
      id: optionProps.id,
      value: option.value,
      label: option.label,
      clientId: getClientId && getClientId(option) || undefined,
      key: option.value,
      onChange: e => changeHandler(option, e),
      onInvalid: e => onInvalid(option, e),
      isRequired: isRequired,
      isInvalid: isInvalid,
      isChecked: selected !== null && option.value === selected.value,
      isDisabled: isDisabled || disabledOptionLookup[option.value] !== undefined,
      size: size
    });
  }));
};
exports.RadioGroup = RadioGroup;
function getDefaultSpacing(orientation) {
  if (orientation === "horizontal") {
    return "large";
  } else {
    return "small";
  }
}
//# sourceMappingURL=RadioGroup.js.map